import { upperCaseFirstLetter } from './text';

const dataUnitDelimiter = 1000;
enum DataUnit {
    b = 0,
    kb = 1,
    mb = 2,
    gb = 3,
}

type DataValue = {
    value: number;
    unit: DataUnit;
    unitLabel: string;
};

export const showDataWithUnit = (dataVolume = 0, dataVolumeUnit?: string): string => {
    return `${dataVolume} ${dataVolumeUnit ? upperCaseFirstLetter(dataVolumeUnit) : dataVolume ? '' : 'b'}`;
};

export const bytesToDataUnit = (bytes: number): DataValue | undefined => {
    if (!Number.isFinite(bytes) || bytes < 0) {
        return undefined;
    }

    for (let unit = DataUnit.gb; unit > DataUnit.b; unit--) {
        const divider = dataUnitDelimiter ** unit;

        if (bytes >= divider && bytes % divider === 0) {
            return {
                value: bytes / divider,
                unit,
                unitLabel: DataUnit[unit],
            };
        }
    }

    return {
        value: bytes,
        unit: DataUnit.b,
        unitLabel: DataUnit[DataUnit.b],
    };
};

export const dataUnitToBytes = (value: number, unit: string): number | undefined => {
    if (!Number.isFinite(value) || value < 0) {
        return undefined;
    }

    const unitKey = unit.toLowerCase() as keyof typeof DataUnit;
    const unitValue = DataUnit[unitKey];

    if (typeof unitValue !== 'number') {
        return undefined;
    }

    return value * dataUnitDelimiter ** unitValue;
};
